import axios from "axios";
import AppSecureStorage from "../secureStorage";
import { API_ROUTES, CONFIG } from "../../utils/constants";

const storage = new AppSecureStorage();

export class AxiosBase {
  instance = axios.create({
    baseURL: API_ROUTES.BASE_URL,
    timeout: CONFIG.TIMEOUT,
    headers: {
      "access-control-allow-origin": "*",
      "Access-Control-Allow-Headers": "Content-Type, Authorization",
      "Access-Control-Allow-Methods": "*",
      "Content-Type": "application/json",
      withCredentials: true,
      credentials: "same-origin",
    },
  });

  axiosInterceptor = this.instance.interceptors.request.use(function (config) {
    const token = storage.get("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  });

  responseBody = (response) => response.data;

  responseError = (error) => {
    throw error.response;
  };

  requests = {
    get: (url) =>
      this.instance.get(url).then(this.responseBody).catch(this.responseError),

    post: (url, body, config = {}) =>
      this.instance
        .post(url, body, {
          ...config,
          headers: {
            "Content-Type":
              body instanceof FormData ? undefined : "application/json",
          },
        })
        .then(this.responseBody)
        .catch(this.responseError),

    put: (url, body) =>
      this.instance
        .put(url, body, {
          headers: {
            "Content-Type":
              body instanceof FormData ? undefined : "application/json",
          },
        })
        .then(this.responseBody)
        .catch(this.responseError),

    patch: (url, body) =>
      this.instance
        .patch(url, body, {
          headers: {
            "Content-Type":
              body instanceof FormData ? undefined : "application/json",
          },
        })
        .then(this.responseBody)
        .catch(this.responseError),

    delete: (url, body) =>
      this.instance
        .delete(url, { data: body })
        .then(this.responseBody)
        .catch(this.responseError),
  };
}
